document.addEventListener('DOMContentLoaded', function () {
  const videoList = document.querySelectorAll('video');

  if (videoList && videoList.length > 0) {
    videoList.forEach((video) => {
      video.setAttribute("controlslist", "nodownload");

      /* Standard syntax */
      document.addEventListener("fullscreenchange", function () {
        if (document.fullscreenElement) {
          video.style.mixBlendMode = "initial";
          return;
        }
        video.style.mixBlendMode = "multiply";
      });

      /* Firefox syntax */
      document.addEventListener("mozfullscreenchange", function () {
        if (document.mozFullScreenElement) {
          video.style.mixBlendMode = "initial";
          return;
        }
        video.style.mixBlendMode = "multiply";
      });

      /* Chrome, Safari and Opera syntax */
      document.addEventListener("webkitfullscreenchange", function () {
        if (document.webkitFullscreenElement) {
          video.style.mixBlendMode = "initial";
          return;
        }
        video.style.mixBlendMode = "multiply";
      });
    });
  } 

  // Doofinder intervention- not used
  // const hashid = "1590f27a98250cb5dd78b19ac2742657";
  // const hashidShop = "8ccff0e5b802b30b96193e4a1d2b5eea";

  // function waitForDoofinder() {

  //     var doofinder_script ='//cdn.doofinder.com/media/js/doofinder-embedded.7.latest.min.js';
  //     (function(d,t){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];f.async=1;
  //       f.src=('https:'==location.protocol?'https:':'http:')+doofinder_script;
  //       f.setAttribute('charset','utf-8');
  //       s.parentNode.insertBefore(f,s)}(document,'script')
  //     );
  //     var dfEmbeddedLayers = [{
  //       "queryInput": "#input-sections--22689063633174__footer--contactemail",
  //       "hashid": '8ccff0e5b802b30b96193e4a1d2b5eea',
  //       "zone": "eu1",
  //       "display": {
  //         "lang": 'en'
  //       }
  //     }];
    
  //     /*var doofinder_script ='//cdn.doofinder.com/media/js/doofinder-classic.7.latest.min.js';
  //     var requirejs = "//cdnjs.cloudflare.com/ajax/libs/require.js/2.3.7/require.min.js";
    
  //     (function(d,t){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];f.async=1;
  //       f.src=('https:'==location.protocol?'https:':'http:')+doofinder_script;
  //       f.setAttribute('charset','utf-8');
  //       s.parentNode.insertBefore(f,s)}(document,'script')
  //     );
  //     (function(d,t){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];f.async=1;
  //       f.src=('https:'==location.protocol?'https:':'http:')+requirejs;
  //       f.setAttribute('charset','utf-8');
  //       s.parentNode.insertBefore(f,s)}(document,'script')
  //     );
  //     var dfClassicLayers = [{
  //       "queryInput": '#q',
  //       "hashid": '8ccff0e5b802b30b96193e4a1d2b5eea',
  //       "zone": "eu1",
  //       "display": {
  //         "lang": 'en'
  //       },
  //       callbacks: {
  //         resultsReceived: function(response) {
  //           console.log("result reveived doofinder!!!", response);
  //         }
  //       },
        
  //     }];
  //     */
                          
  //     console.log("doofinderlayer installed?", dfEmbeddedLayers[0]);
  // }
  // try {
  //   waitForDoofinder();
  // } catch (error) {
  //   console.log("error when customizing doofinder script");
  //   console.log("error doofinder", error)
  // }
});

